var inputNumberData = {
  name: 'inputNumber',
  data: [{}]
};
export default inputNumberData;